import React, { Component } from "react";
import Window from "../2/Controls/Window";
import Input from "../2/Controls/Input";

class AddEditMember extends Component {
  constructor() {
    super();
    this.state = {
      new: true,
      firstName: "",
      lastName: "",
      emailID: "",
      phoneNo: "",
      relation: "",
      relations: [
        "Spouse",
        "Partner",
        "Son",
        "Daughter",
        "Mother",
        "Father",
        "Other",
      ],
      notes: "",
      dob: { Day: "", Month: "", Year: "" },
      anniversary: { Day: "", Month: "", Year: "" },
      customField1: "",
      customField2: "",
      customField3: "",
      customField4: "",
      customField5: "",
      customField6: "",
      customField1DisplayName: "Custom Field 1",
      customField2DisplayName: "Custom Field 2",
      customField3DisplayName: "Custom Field 3",
      customField4DisplayName: "Custom Field 4",
      customField5DisplayName: "Custom Field 5",
      customField6DisplayName: "Custom Field 6",
    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.onSave();
    }
  }

  async componentDidMount() {
    this.props.config.CustomFields.map((customField) => {
      if (customField.ModuleName === "Customer") {
        let customField1DisplayName =
          customField.CustomField1Name.trim() === ""
            ? "Custom Field 1"
            : customField.CustomField1Name.trim();
        let customField2DisplayName =
          customField.CustomField2Name.trim() === ""
            ? "Custom Field 2"
            : customField.CustomField2Name.trim();
        let customField3DisplayName =
          customField.CustomField3Name.trim() === ""
            ? "Custom Field 3"
            : customField.CustomField3Name.trim();
        let customField4DisplayName =
          customField.CustomField4Name.trim() === ""
            ? "Custom Field 4"
            : customField.CustomField4Name.trim();
        let customField5DisplayName =
          customField.CustomField5Name.trim() === ""
            ? "Custom Field 5"
            : customField.CustomField5Name.trim();
        let customField6DisplayName =
          customField.CustomField6Name.trim() === ""
            ? "Custom Field 6"
            : customField.CustomField6Name.trim();
        this.setState({
          customField1DisplayName: customField1DisplayName,
          customField2DisplayName: customField2DisplayName,
          customField3DisplayName: customField3DisplayName,
          customField4DisplayName: customField4DisplayName,
          customField5DisplayName: customField5DisplayName,
          customField6DisplayName: customField6DisplayName,
        });
      }
    });
    console.log("this.props.selectedMember", this.props.selectedMember);
    if (this.props.selectedMember) {
      this.setState({
        new: false,
        firstName: this.props.selectedMember.FirstName,
        lastName: this.props.selectedMember.LastName,
        emailID: this.props.selectedMember.EmailID,
        phoneNo: this.props.selectedMember.PhoneNo,
        dob: this.props.selectedMember.DOB,
        anniversary: this.props.selectedMember.Anniversary,
        notes: this.props.selectedMember.Notes,
        relation: this.props.selectedMember.Relation,
        customField1: this.props.selectedMember.CustomField1,
        customField2: this.props.selectedMember.CustomField2,
        customField3: this.props.selectedMember.CustomField3,
        customField4: this.props.selectedMember.CustomField4,
        customField5: this.props.selectedMember.CustomField5,
        customField6: this.props.selectedMember.CustomField6,
      });
    }
  }

  onSave() {
    if (this.state.firstName.trim() === "") {
      this.setState({ firstNameError: "Please enter name" });
      return;
    }

    let memberDetails = {
      FirstName: this.state.firstName,
      LastName: this.state.lastName,
      EmailID: this.state.emailID,
      PhoneNo: this.state.phoneNo,
      DOB: this.state.dob,
      Anniversary: this.state.anniversary,
      Notes: this.state.notes,
      Relation: this.state.relation,
      CustomField1: this.state.customField1,
      CustomField2: this.state.customField2,
      CustomField3: this.state.customField3,
      CustomField4: this.state.customField4,
      CustomField5: this.state.customField5,
      CustomField6: this.state.customField6,
    };
    this.props.onSave(memberDetails, this.props.selectedIndex);
    this.props.onClose();
  }

  render() {
    return (
      <Window
        header={
          this.props.selectedMember ? "Edit Member Details" : "Add New Member"
        }
        width={"600px"}
        modal={false}
        onClose={this.props.onClose}
        onButtonClick={(buttonType) => {
          if (buttonType.toLowerCase() === "save") {
            this.onSave();
          } else {
            this.props.onClose();
          }
        }}
        buttons={[
          { Type: "secondary", Text: "Cancel", Align: "left" },
          { Type: "primary", Text: "Save", Align: "right" },
        ]}
      >
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              label="First Name"
              onChange={(value) => {
                this.setState({ firstName: value, firstNameError: "" });
              }}
              value={this.state.firstName}
              error={this.state.firstNameError}
              onEnter={this.onSave}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="text"
              label="Last Name"
              onChange={(value) => {
                this.setState({ lastName: value });
              }}
              value={this.state.lastName}
              onEnter={this.onSave}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="mobileno"
              label="Phone Number"
              onChange={(value) => {
                const phoneNo = value;
                let phoneNoError = "";

                if (phoneNo.length > 0 && phoneNo.length !== 10) {
                  phoneNoError = "Phone number must be 10 digits";
                }

                this.setState({
                  phoneNo: phoneNo.length > 10 ? this.state.phoneNo : phoneNo,
                  phoneNoError: phoneNoError,
                });
              }}
              value={this.state.phoneNo}
              error={this.state.phoneNoError}
              onEnter={this.onSave}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="emailid"
              label="Email"
              onChange={(value) =>
                this.setState({
                  emailID: value,
                  emailError: "",
                })
              }
              value={this.state.emailID}
              error={this.state.emailError}
              onEnter={this.onSave}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="dateentry"
              label="Date Of Birth"
              value={this.state.dob}
              onChange={(value) => this.setState({ dob: value })}
              onEnter={this.onSave}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="dateentry"
              label="Anniversary Date"
              value={this.state.anniversary}
              onChange={(value) => this.setState({ anniversary: value })}
              onEnter={this.onSave}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              label="Relation"
              type="select"
              onChange={(value) => this.setState({ relation: value })}
              value={this.state.relation}
              onEnter={this.onSave}
            >
              <option>Please select</option>
              {this.state.relations.map((m) => (
                <option value={m}>{m}</option>
              ))}
            </Input>
          </div>
          <div className="col-md-6">
            <Input
              label="Notes"
              type="textarea"
              onChange={(value) => this.setState({ notes: value })}
              value={this.state.notes}
              onEnter={this.onSave}
            ></Input>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              label={this.state.customField1DisplayName}
              onChange={(value) => this.setState({ customField1: value })}
              value={this.state.customField1}
              onEnter={this.onSave}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="text"
              label={this.state.customField2DisplayName}
              onChange={(value) => this.setState({ customField2: value })}
              value={this.state.customField2}
              onEnter={this.onSave}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              label={this.state.customField3DisplayName}
              onChange={(value) => this.setState({ customField3: value })}
              value={this.state.customField3}
              onEnter={this.onSave}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="text"
              label={this.state.customField4DisplayName}
              onChange={(value) => this.setState({ customField4: value })}
              value={this.state.customField4}
              onEnter={this.onSave}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              label={this.state.customField5DisplayName}
              onChange={(value) => this.setState({ customField5: value })}
              value={this.state.customField5}
              onEnter={this.onSave}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="text"
              label={this.state.customField6DisplayName}
              onChange={(value) => this.setState({ customField6: value })}
              value={this.state.customField6}
              onEnter={this.onSave}
            />
          </div>
        </div>
      </Window>
    );
  }
}

export default AddEditMember;
